import axios from 'axios'

const apiUrl = process.env.VUE_APP_API_URL;
const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  getText(id) {
    return apiClient.get('/text/' + id);
  },
  getTextsByKey(key) {
    return apiClient.get('/text/?key=' + key);
  },
  getAppInfo() {
    return apiClient.get('/app');
  },

  createPhoto(data) {
    return apiClient.post('/photo', data, {
      headers: {
        'Content-Type': `multipart/form-data`
      },
      timeout: 120000
    });
  },
  getPhotoErrors(key, token) {
    return apiClient.get('/photo/' + key + '?expand=errors', {
      headers: {'Authorization': "bearer " + token}
    });
  },
  getPhotoVariants(key,token) {
    return apiClient.get('/photo/' + key + '?expand=variants', {
      headers: {'Authorization': "bearer " + token}
    })
  },
  setPhotoVariant(key,variantId,token) {
    return apiClient.get('/photo/setvariant/' + key + '/' + this.selectedVariant, {
      headers: {'Authorization': "bearer " + token}
    })
  },

  createOrder(data,token) {
    return apiClient.post('/order',data,{
      headers: {'Authorization': "bearer " + token}
    })
  },
  getOrder(key,token) {
    return apiClient.get('/order/' + key, {
      headers: {'Authorization': "bearer " + token}
    })
  }
}